import { axiosClient } from "services/axios";

import { Item } from "../../../types";

import { GetProductsParams } from "../types";

export const PRODUCTS_PAGE_SIZE = 200;

export function getProducts({
  page = 1,
  pageSize = PRODUCTS_PAGE_SIZE,
  group,
  search,
}: GetProductsParams = {}): Promise<Item[] | void> {
  return axiosClient
    .get("items/", {
      params: {
        page,
        pageSize,
        group,
        ...(search !== undefined && search !== "" && { search }),
      },
    })
    .then((res) => res.data as Item[]);
}

export function getItem(itemid: string | number) {
  return axiosClient
    .get("items/item", { params: { itemid: Number(itemid) } })
    .then((res) => {
      const data = res.data as Item[] | Item;
      if (Array.isArray(data)) return data[0] ?? null;
      return data ?? null;
    });
}

export function deleteProduct(itemid: string | number) {
  return axiosClient.post("items/item-delete", {
    itemid: Number(itemid),
  });
}
